// eslint-disable-next-line import/prefer-default-export
export const REGION_CHANGE = 'REGION_CHANGE';
